import options from './dashboard-chart.component';

export default {
    selector: 'dtDashboardChart',
    options
};
